// The reasons a researcher can choose from when disqualifying a respondent in the Respondent
// Manager. Promoted out of RespondentManagerBulkActionComponent for NK-322, where the Quality
// pillar's DAR messages have to decide whether a stored reason is one Navigator recognises.
//
// This is the only carrier of a removal reason that constrains what it can say. The Decipher
// survey variable, the Decipher marker and the QCRemovalReason column of an uploaded
// reconciliation file all carry free text, so a value matching nothing here is researcher or
// client wording and must be counted rather than named.

// The known reasons a removal can carry, worded as the disqualify picker words them.
export const QC_REMOVAL_REASONS = ['Speeder', 'Straight liner', 'Bad open ends', 'Out of country IP'];

// The picker's full option list. 'None' clears a reason and 'Other' reveals the free-text field,
// so neither is a reason a removal can end up carrying - read QC_REMOVAL_REASONS for that.
export const QC_REMOVAL_REASON_OPTIONS = ['None', ...QC_REMOVAL_REASONS, 'Other'];
